import React from "react";
import { Button, Modal, Row, Col } from "react-bootstrap";
import { format } from "date-fns";
const FaqDetailsModal = ({
  faqForDetails,
  showDetailModal,
  setShowDetailmodal,
  setFaqForDetails,
}) => {
  return (
    <Modal
      show={showDetailModal}
      onHide={() => {
        setFaqForDetails({});
        setShowDetailmodal(!showDetailModal);
      }}
      size="lg"
      centered
    >
      <Modal.Header closeButton className="bg-dark text-light">
        <Modal.Title>FAQ Details</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark">
        <Row className="mb-3">
          {Object.entries({
            Question: faqForDetails.question,
            Answer: faqForDetails.answer,
          }).map(([key, value]) => (
            <Col xs={12} md={12} lg={12} className="mb-3" key={key}>
              <div className="p-3 bg-secondary bg-opacity-10 rounded">
                <span className="text-secondary fs-6 fw-semibold">{key}</span>
                <span className="d-block fs-5 fw-medium">{value}</span>
              </div>
            </Col>
          ))}
          {Object.entries({
            Category: faqForDetails?.faq_category?.title || "",
            Status: faqForDetails.status === 1 ? "Active" : "Inactive",
            Created_At:
              faqForDetails.createdAt && format(faqForDetails.createdAt, "PP"),
            Updated_At:
              faqForDetails.updatedAt && format(faqForDetails.updatedAt, "PP"),
          }).map(([key, value]) => (
            <Col xs={12} md={12} lg={6} className="mb-3" key={key}>
              <div className="p-3 bg-secondary bg-opacity-10 rounded">
                <span className="text-secondary fs-6 fw-semibold">{key}</span>
                <span className="d-block fs-5 fw-medium">{value}</span>
              </div>
            </Col>
          ))}
        </Row>
      </Modal.Body>
      <Modal.Footer className="bg-dark text-light">
        <Button
          variant="secondary"
          onClick={() => {
            setFaqForDetails({});
            setShowDetailmodal(!showDetailModal);
          }}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FaqDetailsModal;
